import { render, staticRenderFns } from "./BestBuysNowVotes.vue?vue&type=template&id=6a5c55f9&scoped=true"
import script from "./BestBuysNowVotes.vue?vue&type=script&lang=js"
export * from "./BestBuysNowVotes.vue?vue&type=script&lang=js"
import style0 from "./BestBuysNowVotes.vue?vue&type=style&index=0&id=6a5c55f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c55f9",
  null
  
)

export default component.exports